module.exports = "/_next/static/images/EnsureDataPrivacy@2x-cec986d2d1a1812395897b379bee99b1.webp";